"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_WIZARD_ORG_NAME = void 0;
exports.DEFAULT_WIZARD_ORG_NAME = 'wizard_ops';
//# sourceMappingURL=org-defaults.js.map